import React from "react";

const SubCategoryComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default SubCategoryComponent;
